<div class="content">
  <h1>Добро пожаловать {{auth.user.fullname | fio}}!</h1>
</div>
